import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './ProfileBanner.css';

class ProfileBanner extends PureComponent {
  static propTypes = {
    bannerImageUrl: PropTypes.string,
  };

  renderImage = bannerImageUrl => {
    const imageStyle = {
      backgroundImage: `url("${bannerImageUrl}")`,
    };

    return (
      <div className={styles.container}>
        <figure className={styles.image} style={imageStyle} alt="" />
      </div>
    );
  };

  render() {
    const { bannerImageUrl } = this.props;

    if (!bannerImageUrl) {
      return null;
    }

    return this.renderImage(bannerImageUrl);
  }
}

export default ProfileBanner;
